module.exports = "/_next/static/images/avatar-bg-cf948ea0.png";